module.exports = function(approval) {
	'use strict'
	approval.directive('allApprovalsDir',allApprovalsDir);
	allApprovalsDir.$inject=[];
	function allApprovalsDir() {
		return {
			restrict: 'E',
			template: require('./partial/allapprovals.html'),
			controller:'allApprovalsController',
			controllerAs:'vmaa',
			link: function(scope, element, attrs, ctrl) {
				
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/approvalsModule/allapprovals/js/directive/allApprovalsDirective.js
// module id = 491
// module chunks = 0